@if (block && block.numbers.length > 0) {
  <div class="card card-nb h-100 phonenumber" [ngClass]="{ 'hover-effect': canShowDetails }">
    <div class="position-absolute" style="top: 0.74rem; right: 0.6rem;">
      @if (isBlockActive && isAdmin && isNotATrial) {
        <div
          class="custom-dropdown-menu" ngbDropdown display="dynamic" placement="bottom-right" (click)="openSubscription()">
          <button class="btn bg-transparent p-2 m-0 hide-dropdown-icon" id="dropdownBasic2" ngbDropdownToggle>
            <i class="fas fa-ellipsis-v red icon-size-bigger navbar-profile-icon"></i>&nbsp;
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic2">
            @if(subscriptionInput) {
              @if (hasScheduledOrder) { 
                <div class="cursor-pointer dropdown-item" (click)="cancelOrder()">
                  <span class="d-flex">
                    <i class="fa fa-ban red icon-size-big mr-2"></i>
                    <span>{{ 'cancel_order' | i18next }}</span>
                  </span>
                </div>
              } @else {
                <div class="cursor-pointer dropdown-item" (click)="cancelPhoneNumber()">
                  <span class="d-flex">
                    <i class="fa fa-ban red icon-size-big mr-2"></i>
                    <span>{{ 'cancel_phone_number' | i18next }}</span>
                  </span>
                </div>
              }
            } @else {
              <div class="spinner">
                <img class="center" src="assets/images/loading.gif" alt="Loading content">
              </div>
            }
          </div>
        </div>
      }
    </div>
    <div class="card-body pb-0 d-flex flex-column" (click)="showDetails()">
      <div class="d-flex justify-content-between">
        <app-subscription-title [ngClass]="{'red huline': canShowDetails}" [subscription]="subscription"></app-subscription-title>
      </div>
      <div class="subinformations mt-2" style="min-height: 80px;">
        <div>
          @if (isBlock) {
            <app-phonenumber-block
              [from]="block.fromNumber"
              [to]="block.toNumber"
              [length]="block.numbers.length"
            [deliveryDate]="block.delivery_date"></app-phonenumber-block>
          }
          @if (!isBlock) {
            <app-phonenumber-single
              [from]="block.fromNumber"
              [deliveryDate]="block.delivery_date"
            [locationIndependent]="block.locationIndependent"></app-phonenumber-single>
          }
        </div>
      </div>
      @if (isAdmin && hasScheduledOrder) {
      <div class="d-flex mt-3 justify-content-end">
        <span>{{ 'cancel_phonenumber_cancel_order_info_text' | i18next: { date: (scheduledOrder?.deliveryDate| localized_date) } }}</span>
        <a (click)="cancelOrder(); $event.stopPropagation()" class="ml-1 red cursor-pointer">{{ 'cancel_order' | i18next }}</a>
      </div>
      }
      <div class="row mt-auto subinformations pb-1">
        <div class="d-flex ml-auto align-items-end flex-column h-100">
          <div class="mt-auto" style="min-height: 22px;">
            <span [class]="cssClass" class="mr-2 status-text">{{ statusTranslationKey | i18next }}</span>
            <span>
              <i class="fas fa-info-circle red" [pTooltip]="statusDescriptionTranslationKey | i18next" [tooltipEvent]="deviceService.tooltipEvent" tabindex="0"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="m-0 pt-1 status-bg" [class]="cssClass" ></div>
  </div>
}

